export default "__VITE_ASSET__snQ$RbCo__"